// API_URL is read from VUE_APP_API_URL in .env.development.local, which is
// gitignored and only applies to `npm run serve` (development mode) -- it
// is NOT loaded by `npm run build` (production mode, used for UAT/prod
// deploys), so it can't accidentally leak a local URL into a real build.
// To point local dev at a different backend, edit .env.development.local --
// do not change the value below, since that's what every build deploys with.
// Falls back to the UAT API when no local override is present.
export const API_URL = process.env.VUE_APP_API_URL || "https://uatscanapi.totalbiometrics.net/api/v1";
export default API_URL;

// # building the dist/ that goes to the UAT branch
// VUE_APP_API_URL=https://uatscanapi.totalbiometrics.net/api/v1 npm run build

// # building the dist/ that goes to the production branch
// VUE_APP_API_URL=https://scanapi.totalbiometrics.net/api/v1 npm run build
